const regex = /^([0-9]{4})([0-9]{4})([0-9]{4})([0-9]{4})$/;
const getMessage = () => `請輸入有效的信用卡號碼`;
const validate = (value) => regex.test(value);

/** 自訂驗證 信用卡 格式 */
export default {
  getMessage,
  validate,
};
